import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigOptionComponent } from './common-components/config-option/config-option.component';
import { LoadingBarComponent } from './common-components/loading-bar/loading-bar.component';
import { TopBarComponent } from './common-components/top-bar/top-bar.component';
import { CodeGameComponent } from './pages/code-game/code-game.component';
import { DoorEditorComponent } from './pages/door-editor/door-editor.component';
import { MainMenuComponent } from './pages/main-menu/main-menu.component';
import { MyDoorsComponent } from './pages/my-doors/my-doors.component';
import { TitleScreenComponent } from './pages/title-screen/title-screen.component';
import { CodeDisplayComponent } from './common-components/code-display/code-display.component';
import { LevelSelectorComponent } from './pages/level-selector/level-selector.component';
import { ScoreNumberPipe } from './pipes/score-number.pipe';
import { DigitComponent } from './common-components/digit/digit.component';


@NgModule({
  declarations: [
    AppComponent,
    TitleScreenComponent,
    LoadingBarComponent,
    TopBarComponent,
    MainMenuComponent,
    CodeGameComponent,
    MyDoorsComponent,
    DoorEditorComponent,
    ConfigOptionComponent,
    CodeDisplayComponent,
    LevelSelectorComponent,
    ScoreNumberPipe,
    DigitComponent
  ],
  imports: [
    BrowserModule, BrowserAnimationsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
